import React from 'react';
import { auditLogs } from '../../data/adminMock';
import { Search, Download, Filter, Clock, User, Activity } from 'lucide-react';

const AdminLogs = () => {
  return (
    <div className="p-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-white mb-2">Audit Logs</h1>
          <p className="text-gray-400">Track all system activities and changes</p>
        </div>
        <button className="flex items-center gap-2 border border-gray-700 text-gray-300 hover:bg-gray-800 px-4 py-2 rounded-lg transition-colors">
          <Download className="w-5 h-5" />
          Export Logs
        </button>
      </div>

      {/* Filters */}
      <div className="bg-[#0d1117] border border-gray-800 rounded-xl p-4 mb-6">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500" />
            <input
              type="text"
              placeholder="Search by action, user, or target..."
              className="w-full bg-[#1a1a1f] border border-gray-700 rounded-lg pl-12 pr-4 py-2.5 text-white placeholder-gray-500 outline-none focus:border-teal-400"
            />
          </div>
          <select className="bg-[#1a1a1f] border border-gray-700 rounded-lg px-4 py-2.5 text-gray-300 outline-none focus:border-teal-400">
            <option>All Actions</option>
            <option>User Created</option>
            <option>User Suspended</option>
            <option>Agent Deployed</option>
            <option>Settings Updated</option>
            <option>Permission Changed</option>
          </select>
          <input
            type="date"
            className="bg-[#1a1a1f] border border-gray-700 rounded-lg px-4 py-2.5 text-gray-300 outline-none focus:border-teal-400"
          />
        </div>
      </div>

      {/* Logs Table */}
      <div className="bg-[#0d1117] border border-gray-800 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#1a1a1f]">
              <tr>
                <th className="text-left text-gray-400 text-xs font-medium px-6 py-4">ACTION</th>
                <th className="text-left text-gray-400 text-xs font-medium px-6 py-4">USER</th>
                <th className="text-left text-gray-400 text-xs font-medium px-6 py-4">TARGET</th>
                <th className="text-left text-gray-400 text-xs font-medium px-6 py-4">IP ADDRESS</th>
                <th className="text-left text-gray-400 text-xs font-medium px-6 py-4">TIMESTAMP</th>
              </tr>
            </thead>
            <tbody>
              {auditLogs.map((log) => (
                <tr key={log.id} className="border-t border-gray-800 hover:bg-[#1a1a1f]/50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                        log.action.includes('Created') ? 'bg-green-400/10' :
                        log.action.includes('Suspended') || log.action.includes('Delete') ? 'bg-red-400/10' :
                        log.action.includes('Changed') || log.action.includes('Updated') ? 'bg-yellow-400/10' :
                        'bg-blue-400/10'
                      }`}>
                        <Activity className={`w-4 h-4 ${
                          log.action.includes('Created') ? 'text-green-400' :
                          log.action.includes('Suspended') || log.action.includes('Delete') ? 'text-red-400' :
                          log.action.includes('Changed') || log.action.includes('Updated') ? 'text-yellow-400' :
                          'text-blue-400'
                        }`} />
                      </div>
                      <span className="text-white font-medium">{log.action}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <User className="w-4 h-4 text-gray-500" />
                      <span className="text-gray-300">{log.user}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className="text-gray-300">{log.target}</span>
                  </td>
                  <td className="px-6 py-4">
                    <span className="text-gray-500 font-mono text-sm">{log.ip}</span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4 text-gray-500" />
                      <span className="text-gray-300 text-sm">{log.timestamp}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="px-6 py-4 border-t border-gray-800 flex items-center justify-between">
          <p className="text-gray-500 text-sm">Showing 1-8 of 248 logs</p>
          <div className="flex gap-2">
            <button className="px-3 py-1.5 border border-gray-700 text-gray-400 rounded hover:bg-gray-800 transition-colors text-sm">
              Previous
            </button>
            <button className="px-3 py-1.5 bg-teal-400/10 text-teal-400 border border-teal-400/30 rounded text-sm">
              1
            </button>
            <button className="px-3 py-1.5 border border-gray-700 text-gray-400 rounded hover:bg-gray-800 transition-colors text-sm">
              2
            </button>
            <button className="px-3 py-1.5 border border-gray-700 text-gray-400 rounded hover:bg-gray-800 transition-colors text-sm">
              3
            </button>
            <button className="px-3 py-1.5 border border-gray-700 text-gray-400 rounded hover:bg-gray-800 transition-colors text-sm">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogs;
